module.exports = __webpack_public_path__ + "img/submit.2df0fabb.png";